/** Política de vida del socket de avisos: cada cuánto late y cuánto espera para reconectar. */

/**
 * Cada cuánto se manda el `heartbeat`. La conexión caduca a las 2 h o al vencer la sesión (1 h), lo
 * que pase primero; el latido renueva el TTL de la fila y mantiene viva la conexión de API Gateway.
 */
export const HEARTBEAT_INTERVAL_MS = 45_000;

export const RECONNECT_BASE_MS = 1_000;
export const RECONNECT_MAX_MS = 30_000;

/**
 * Espera antes del siguiente intento: exponencial con techo. El tope importa porque una sesión
 * vencida rechaza el handshake una y otra vez, y sin techo eso sería un martilleo.
 */
export function reconnectDelayMs(attempt: number, random: () => number = Math.random): number {
    const exponent = Math.min(Math.max(attempt, 0), 10);
    const capped = Math.min(RECONNECT_BASE_MS * 2 ** exponent, RECONNECT_MAX_MS);
    // Jitter ±20%: varias tabletas que pierden el canal a la vez no vuelven todas en el mismo ms.
    return Math.round(capped * (0.8 + 0.4 * random()));
}
